module.exports = __webpack_public_path__ + "img/1.a25b1941.png";